'use es6';

import { List, Map as ImmutableMap } from 'immutable';
export default (data => {
  if (data.hasIn([0, 'total'])) {
    return data.getIn([0, 'total', 'raw']) === 0;
  }
  const buckets = data.getIn([0, 'dimension', 'buckets'], List()).reduce((memo, bucket) => bucket.has('dimension') ? /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  memo.concat(bucket.getIn(['dimension', 'buckets'], List())) : /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  memo.concat(List(bucket)), List());
  const metrics = data.getIn([0, 'metrics'], ImmutableMap());
  return data.hasIn([0, 'dimension']) ? buckets.isEmpty() : metrics.isEmpty();
});